import React from 'react';

function AddAttendance() {
  return <div>AddAttendance</div>;
}

export default AddAttendance;
